<template>
  <el-menu :default-active="active" @select="handleSelect" class="side-menu">
    <el-menu-item index="top">
      <el-icon>
        <Sunrise />
      </el-icon>
      <span>顶 部</span>
    </el-menu-item>

    <el-menu-item index="footprint">
      <el-icon>
        <Guide />
      </el-icon>
      <span>足 迹</span>
    </el-menu-item>

    <el-menu-item index="collection">
      <el-icon>
        <Trophy />
      </el-icon>
      <span>撷 英</span>
    </el-menu-item>

    <el-menu-item index="writing">
      <el-icon>
        <ChatDotRound />
      </el-icon>
      <span>省 思</span>
    </el-menu-item>
    <el-menu-item index="research">
      <el-icon>
        <ship />
      </el-icon>
      <span>求 索</span>
    </el-menu-item>
  </el-menu>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import {
  ChatDotRound,
  Guide,
  Ship,
  Sunrise,
  Trophy,
} from "@element-plus/icons-vue";

const active = ref("top");
const sections = ["writing", "collection", "footprint", "top"];
const goAnchor = (selector: string) => {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
    });
  }
};
const handleSelect = (key: string) => {
  if (key == "research") {
    window.open("#/research");
  } else {
    goAnchor(`#${key}`);
  }
};
const listenScroll = () => {
  for (const section of sections) {
    const element = document.querySelector(`#${section}`);
    if (element && element.getBoundingClientRect().top <= 0) {
      active.value = section;
      break;
    }
  }
};

onMounted(() => {
  document.addEventListener("scroll", listenScroll);
});

onUnmounted(() => {
  document.removeEventListener("scroll", listenScroll);
});
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}

.side-menu {
  right: 0;
  width: 100px;
  opacity: 0.8;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 8px 0 rgba(25, 14, 109, 0.13);
}

@media (max-width: 768px) {
  .side-menu {
    scale: 70%;
    transform-origin: right center;
  }
}
</style>
